const root = '/users';
const current = `${root}/current`;

// change password
const passwordRoot = '/password';
const password = {
  change: `${passwordRoot}/change`,
  forgot: `${passwordRoot}/reset`,
  confirm: (userId, token) => `${passwordRoot}/reset/confirm/${userId}/${token}`
};

const customer = '/customer';
const userToken = '/api/get-token';

export const usersEndpoints = {
  current,
  password,
  customer,
  userToken
};
